import { render, staticRenderFns } from "./workspace-members-view.vue?vue&type=template&id=588276f8&scoped=true&"
import script from "./workspace-members-view.vue?vue&type=script&lang=js&"
export * from "./workspace-members-view.vue?vue&type=script&lang=js&"
import style0 from "./workspace-members-view.vue?vue&type=style&index=0&id=588276f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588276f8",
  null
  
)

export default component.exports